import React from 'react';
import deepmerge from '@mui/utils/deepmerge';
import { Chip as MuiChip, ChipProps } from '@mui/material';
import Close from '../../icons/Close';
import styles from './styles';
import getChipStyle from './utility';

export interface LibChipProps extends ChipProps {
  selected?: boolean;
  tag?:
    | 'text'
    | 'positive'
    | 'negative'
    | 'recommended'
    | 'zero-deposit'
    | 'reduced'
    | 'last-viewed'
    | 'recently-sold'
    | 'recently-let'
    | 'recently-add'
    | 'exchanged'
    | 'error'
    | 'red'
    | 'green';
  stayOnText?: boolean;
}

function LibChip({ ...props }: LibChipProps) {
  const { common } = styles;
  const predefinedLabels = {
    positive: props.stayOnText ? props.label : 'Positive',
    negative: props.stayOnText ? props.label : 'Negative',
    error: props.stayOnText ? props.label : 'Error',
    recommended: props.stayOnText ? props.label : 'Recommended',
    exchanged: props.stayOnText ? props.label : 'Exchanged',
    'zero-deposit': 'Zero deposit',
    reduced: 'Reduced',
    'last-viewed': 'Last viewed',
    'recently-sold': 'Recently sold',
    'recently-let': 'Recently let',
    'recently-added': 'Recently added',
    text: props.label,
    red: props.label,
    green: props.label
  };

  return (
    <MuiChip
      deleteIcon={props.deleteIcon || <Close sx={{ width: '0.625rem' }} />}
      {...props}
      sx={deepmerge(
        { ...common },
        deepmerge(
          { ...getChipStyle(props.tag, props.clickable, props.selected) },
          { ...props.sx }
        )
      )}
      label={
        predefinedLabels[props.tag || (props.label as LibChipProps['tag'])] ||
        props.label
      }
    />
  );
}

export const Chip = React.memo(LibChip);

export default Chip;
